export const SpaceViewTypeService = Symbol('SpaceViewTypeService');
